"use strict";

var tooltip = require("_core/tooltip"),
    util = require("_core_ext/util"),
    dialog = require("_core_ext/dialog"),
    page = require("_core_ext/page"),
    validator = require("_core_ext/validator"),
    postcodeanywhere = require("_core_ext/postcodeanywhere"),
    globalintuitive = require("_core_ext/globalintuitive"),
    JSConstants = require("_core_ext/pages/account/constants"),
    qas = require("_core_ext/qas"),
    layout = require('_core_ext/layout'),
    perimeterx = require("_core_ext/trackers/perimeterx"),
    vouchers = require("_core_ext/pages/account/vouchers");

function initShowSuccessMessage() {
    var $message = $(".js-change_profile_message");

    if (!$message.hasClass("hidden")) {
        $message.addClass("hidden");
    }

    if (localStorage.getItem("isMessageShown") === "true") {
        setTimeout(function () {
            $message.removeClass("hidden");
        }, 1000);
    }

    localStorage.removeItem("isMessageShown");
}

function initSubmitForm(formClass, formButtonApply) {
    var $form = $(formClass);

    if ($form && $form.length && formClass === JSConstants.CLASS_CHANGE_PASS_FORM) {
        var urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('invalid') && urlParams.get('invalid') === 'true') {
            $form.valid();
        }
    }

    $form.on("submit", function (e) {
        e.preventDefault();
        var url = util.appendParamToURL($form.attr("action"), "format", "ajax");
        var applyName = $form.find(formButtonApply).attr("name");
        var $message = $(".js-change_profile_message");

        if (!$message.hasClass("hidden")) {
            $message.addClass("hidden");
        }

        if (!$form.hasClass(JSConstants.CLASS_CHANGE_PASS_FORM.substring(1)) && !$form.valid()) {
            return false;
        }

        var options = {
            url: url,
            data: $form.serialize() + "&" + applyName + "=x",
            type: "POST",
        };

        $.ajax(options).done(function (data) {
            if (data.success) {
                $("html, body").animate({ scrollTop: 0 }, "100");
                setTimeout(function () {
                    $message.removeClass("hidden");
                }, 1000);
                $form.find("input.js-password").val("");
            } else {
                var url;
                if (data.pageToRedirect === "editPassword") {
                    url = Urls.continueUrl;
                } else {
                    url = Urls.editProfile;
                }
                url = util.appendParamToURL(url, "invalid", "true");
                page.redirect(url);
            }
        });
    });
}

function initChangeProfileForm() {
    initSubmitForm(
        JSConstants.CLASS_CHANGE_PROFILE_FORM,
        JSConstants.CLASS_CHANGE_PROFILE_APPLY
    );
}

function initChangeLoginForm() {
    initSubmitForm(
        JSConstants.CLASS_CHANGE_LOGIN_FORM,
        JSConstants.CLASS_CHANGE_LOGIN_APPLY
    );
}

function initChangeBusinessCompanyNameForm() {
    initSubmitForm(
        JSConstants.CLASS_CHANGE_BUSINESS_NAME_FORM,
        JSConstants.CLASS_CHANGE_BUSINESS_NAME_APPLY
    );
}

function initChangePasswordForm() {
    initSubmitForm(
        JSConstants.CLASS_CHANGE_PASS_FORM,
        JSConstants.CLASS_CHANGE_PASS_APPLY
    );
}

function initChangeProfessionalForm() {
    initSubmitForm(
        JSConstants.CLASS_CHANGE_PROFESSIONAL_FORM,
        JSConstants.CLASS_CHANGE_PROFESSIONAL_APPLY
    );
}

function getCSRFToken() {
    var $csrfInput = $(JSConstants.CLASS_ADDRESS_TOKEN);
    var obj = {};

    obj[$csrfInput.attr("name")] = $csrfInput.val();

    return obj;
}

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
    var $form = $("#edit-address-form");

    $form.find('input[name="format"]').remove();
    tooltip.init();

    globalintuitive.init(
        {
            fieldsPrefix: "dwfrm_profile_address",
        },
        true
    );

    postcodeanywhere.init(
        {
            fieldsPrefix: "dwfrm_profile_address",
        },
        true
    );
    //$("<input/>").attr({type:"hidden", name:"format", value:"ajax"}).appendTo(form);

    qas.init(); // reinit QAS
    $(document).on("submit", JSConstants.CLASS_ADDRESS_FORM, function (e) {
        e.preventDefault();
    });

    $form
        .on("click", function () {
            validator.init();
        })
        .on("click", JSConstants.CLASS_ADDRESS_FORM_APPLY, function (e) {
            QAScheck(e, submitAddressForm, $form, $(this));
        })
        .on(
            "click touchstart",
            JSConstants.CLASS_ADDRESS_FORM_CLOSE,
            function (e) {
                e.preventDefault();
                dialog.closeSafe();
            }
        )
        .on("click", JSConstants.CLASS_ADDRESS_FORM_DELETE, function (e) {
            e.preventDefault();
            var infoMessage = String.format(
                Resources.CONFIRM_DELETE,
                Resources.TITLE_ADDRESS
            );

            if (window.confirm(infoMessage)) {
                var url = util.appendParamsToUrl(Urls.deleteAddress, {
                    AddressID: $form.find("#addressid").val(),
                    format: "ajax",
                });

                $.ajax({
                    url: url,
                    method: "POST",
                    dataType: "json",
                    data: getCSRFToken(),
                })
                    .done(function (data) {
                        if (data.status.toLowerCase() === "ok") {
                            dialog.close();
                            page.refresh();
                        } else if (data.message.length > 0) {
                            window.alert(data.message);
                            return false;
                        } else {
                            dialog.close();
                            page.refresh();
                        }
                    })
                    .fail(function (response) {
                        var handled = perimeterx.handleResponce(response);

                        if (!handled) {
                            location.reload();
                        }
                    });
            }
        });
}

function submitAddressForm($form) {
    if (!$form.valid()) {
        return false;
    }

    var url = util.appendParamToURL($form.attr("action"), "format", "ajax");
    var applyName = $form
        .find(JSConstants.CLASS_ADDRESS_FORM_APPLY)
        .attr("name");
    var options = {
        url: url,
        data: $form.serialize() + "&" + applyName + "=x",
        type: "POST",
    };

    $.ajax(options).done(function (data) {
        if (typeof data !== "string") {
            if (data.success) {
                dialog.close();
                page.refresh();
                localStorage.setItem("isMessageShown", "true");
            } else if (data.error) {
                page.redirect(Urls.csrffailed);
            } else {
                window.alert(data.message);
                return false;
            }
        } else {
            $("#dialog-container").html(data);
            account.init();
            tooltip.init();
        }
    });

    return false;
}

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder() {
    $(".order-items")
        .find("li.hidden:first")
        .prev("li")
        .append('<a class="toggle">View All</a>')
        .children(".toggle")
        .click(function () {
            $(this).parent().siblings("li.hidden").show();
            $(this).remove();
        });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var $document = $(document);
    var $addresses = $(JSConstants.CLASS_ADDRESS_CONTAINER);
    if ($addresses.length === 0) {
        return;
    }

    $document
        .on(
            "click",
            JSConstants.CLASS_ADDRESS_CREATE +
                ", " +
                JSConstants.CLASS_ADDRESS_EDIT,
            function (e) {
                e.preventDefault();

                $.ajax({
                    type: "GET",
                    dataType: "html",
                    headers: {
                        "X-PERIMETER-TYPE": "json",
                    },
                    url: util.ajaxUrl(this.href),
                })
                    .done(function (response) {
                        if (response) {
                            dialog.open({
                                html: response,
                                options: {
                                    open: function () {
                                        initializeAddressForm();
                                        $('.ui-dialog-title').remove();
                                    },
                                    dialogClass: "address-popup",
                                    outsideClose: false,
                                },
                            });
                        }
                    })
                    .fail(function (response) {
                        perimeterx.handleResponce(response);
                    });
            }
        )
        .on("click", JSConstants.CLASS_ADDRESS_DELETE, function (e) {
            var requestData = { format: "ajax" };

            e.preventDefault();
            if (
                window.confirm(
                    String.format(
                        Resources.CONFIRM_DELETE,
                        Resources.TITLE_ADDRESS
                    )
                )
            ) {
                $.extend(requestData, getCSRFToken());

                $.ajax({
                    url: util.appendParamsToUrl(
                        $(this).attr("href"),
                        requestData
                    ),
                    dataType: "json",
                })
                    .done(function (data) {
                        if (data.status.toLowerCase() === "ok") {
                            page.redirect(Urls.addressesList);
                            localStorage.setItem("isMessageShown", "true");
                        } else if (data.message.length > 0) {
                            window.alert(data.message);
                        } else {
                            page.refresh();
                        }
                    })
                    .fail(function (response) {
                        perimeterx.handleResponce(response);
                    });
            }
        })
        .on("click", JSConstants.CLASS_ADDRESS_CHANGE_DEFAULT, function (e) {
            var requestData = { format: "ajax" };

            e.preventDefault();
            if ($(e.target).hasClass("is-active")) {
                $(this)
                    .closest(".address-list_content")
                    .find(".address-error-message")
                    .show();
                return;
            }
            $.extend(requestData, getCSRFToken());

            $.ajax({
                url: util.appendParamsToUrl($(this).attr("href"), requestData),
                dataType: "json",
            })
                .done(function () {
                    $.ajax({
                        url: util.appendParamToURL(
                            Urls.getAddressList,
                            "format",
                            "ajax"
                        ),
                    }).done(function (addressesHTML) {
                        $document
                            .find(JSConstants.CLASS_ADDRESS_CONTAINER)
                            .replaceWith($(addressesHTML));
                    });
                })
                .fail(function (response) {
                    var handled = perimeterx.handleResponce(response);

                    if (!handled) {
                        location.reload();
                    }
                });
        });
}

function scrollToAddressList() {
    $(document).on(
        "click",
        JSConstants.CLASS_ADDRESS_CONTENT_LINK,
        function (e) {
            var offset = $(this).data("offset") || 0;
            var totalOffset = $("#address-list").offset().top - offset;

            e.preventDefault();
            util.scrollBrowser(totalOffset, 500, true);
        }
    );
}

function scrollToFirstError() {
    var $errorField = $(".form-row_error").first();
    util.scrollBrowserTo($errorField, 500, true);
}

function markCurrentNavLink() {
    var url = window.location;

    $(JSConstants.CLASS_NAV_LINK)
        .filter(function () {
            return this.href === url || url.href.indexOf(this.href) === 0;
        })
        .addClass("account-nav_active");
}

/**
 * @private
 * @function
 * @description Binds the events of the order and address pages
 */
function initializeEvents() {
    initChangeProfileForm();
    initChangeBusinessCompanyNameForm();
    initChangeLoginForm();
    initChangePasswordForm();
    initChangeProfessionalForm();
    toggleFullOrder();
    initAddressEvents();
    markCurrentNavLink();
    scrollToAddressList();
    scrollToFirstError();
    initShowSuccessMessage();

    $(function () {
        util.checkExpiredTradeCard(JSConstants.CLASS_ACCOUNT_OVERVIEW);
    })
        .on("submit", "#js-catalogue-request", function (e) {
            var $currentForm = $(this);
            var $submitButton = $currentForm.find('button[type="submit"]');
            QAScheck(e, false, false, $submitButton, $currentForm);
        })
        .on("submit", JSConstants.CLASS_ADDRESS_FORM, function () {
            $('input[name$="_country"]').removeAttr("disabled");
        });
}

//check Email and Mobile (via Experian) before submit
function QAScheck(e, submitFn, submitFnParams, $submitButton, $currentForm) {
    if (qas.isQASvalidationButton($submitButton)) {
        var promiseExist = qas.validate($submitButton);

        if (promiseExist) {
            e.preventDefault();
            promiseExist.then(function () {
                if (submitFn) {
                    submitFn(submitFnParams);
                }

                if ($currentForm) {
                    $currentForm.append(
                        '<input type="hidden" name="' +
                            $submitButton.attr("name") +
                            '"  />'
                    );
                    $currentForm.submit();
                }
            });
        }
    } else if (submitFn) {
        submitFn(submitFnParams);
    }
}

var account = {
    init: function () {
        initializeEvents();
        qas.init();
        vouchers.init();

        var $searchAddress = $('input[name*="_search"],input.js-search-field');
        if (layout.isMobile() && $searchAddress.length) {
            globalintuitive.init({fieldsPrefix: "dwfrm_profile_address"}, true);
        }
    },
    markCurrentNavLink: markCurrentNavLink,
};

module.exports = account;
